const ROOT_SELECTOR = '.js-banner-hover-video';
const VIDEO_SELECTOR = '.banner-media__video';
const HOVER_ROOT_SELECTOR = '.banner';
const ACTIVE_CLASS = 'is-video-active';

function canUseHoverVideo(): boolean {
  return window.matchMedia('(hover: hover) and (prefers-reduced-motion: no-preference)').matches;
}

function bindBannerHoverVideo(media: HTMLElement): void {
  const hoverRoot = media.closest<HTMLElement>(HOVER_ROOT_SELECTOR) ?? media;
  const video = media.querySelector<HTMLVideoElement>(VIDEO_SELECTOR);

  if (!video) {
    return;
  }

  // Promote the video (paused on its first frame) to the visible layer as soon
  // as that frame can be rendered, so the banner starts on the video's opening
  // frame instead of the static poster. The poster stays up until then.
  const activate = (): void => {
    media.classList.add(ACTIVE_CLASS);
  };

  if (video.readyState >= video.HAVE_CURRENT_DATA) {
    activate();
  }
  else {
    video.addEventListener('loadeddata', activate, { once: true });
  }

  // Loop while hovered (the `loop` attribute keeps it infinite); freeze on the
  // current frame when the pointer leaves — no rewind.
  const play = (): void => {
    void video.play().catch(() => {});
  };

  const freeze = (): void => {
    video.pause();
  };

  hoverRoot.addEventListener('mouseenter', play);
  hoverRoot.addEventListener('mouseleave', freeze);
}

export function initBannerHoverVideo(): void {
  if (!canUseHoverVideo()) {
    return;
  }

  const mediaItems = document.querySelectorAll<HTMLElement>(ROOT_SELECTOR);

  for (const media of mediaItems) {
    bindBannerHoverVideo(media);
  }
}
